import { EuiFlexGroup,EuiFlexItem,EuiFieldNumber, EuiButtonIcon } from '@elastic/eui';
import moment from 'moment';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { SelectorEjercicioContainer as SelectorEjercicio} from '../../../../components/Selectores/Ejercicio/container';

interface Props{
    onChangeFilter(data:number):any;
}

export const EjercicioFilter = forwardRef((props:Props, ref:any) =>{

    const {onChangeFilter} = props;

    const [ejercicio, setEjercicio] = useState<number>(parseInt(moment().format('Y')))

    useEffect(()=>{
        onChangeFilter(ejercicio)
    },[])

    const onRefresh = () =>{
        onChangeFilter(ejercicio)
    }

    useImperativeHandle(
        ref,
        () => ({
            getEjercicio() {
                return ejercicio;
            }
         })
      )

    return (
        <EuiFlexGroup>
            <EuiFlexItem grow={false}> 
                <SelectorEjercicio value={ejercicio} onChange={(e:any) => setEjercicio(e)} permitirNuevo={true} />
            </EuiFlexItem>
            <EuiFlexItem grow={false} style={{justifyContent:'center'}}> 
                <EuiButtonIcon display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()}/>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
});